<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Användarnamn</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="username"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Lösenord</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="password"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Adversus Lead ID</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldAdversusLeadId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const username = ref(null);
const password = ref(null);
const fieldAdversusLeadId = ref(null);
const serializedValue = computed(() => {
  return {
    username: username.value,
    password: password.value,
    field_adversus_lead_id: fieldAdversusLeadId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    username.value = modelValue.value.username;
    password.value = modelValue.value.password;
    fieldAdversusLeadId.value = modelValue.value.field_adversus_lead_id;
  }
}, {
  immediate: true
});
</script>
